import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { BasemapVM } from './BasemapVM';
import './basemap.scss';

const BasemapComponent = (props) => {
  const vm = useRef(new BasemapVM(props)).current;
  useEffect(() => {
    vm.basemapMount(props);
  });
  return null;
};
export const Basemap = observer(BasemapComponent);
